import { CLICKED_PRESCRIPTION_ID, PRESCRIPTION_REQUEST, PRESCRIPTION_REQUEST_ERROR, PRESCRIPTION_REQUEST_SUCCESS } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};
  
export const prescriptionReducer = (state = initialState, action) => {
    switch (action.type) {
    case PRESCRIPTION_REQUEST:        
        return { ...state, loading: true };
    case PRESCRIPTION_REQUEST_SUCCESS :                
        return { ...state, prescriptionDetails : action.payload, page : action.page, loading: false };
    case PRESCRIPTION_REQUEST_ERROR :
        return { ...state,loading: false };
    case CLICKED_PRESCRIPTION_ID :
        return { ...state, prescriptionId : action.prescriptionId };
    default:
        return state;
    }
};
  